module.exports = __webpack_public_path__ + "static/media/phonepe.1f313261.png";